import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import { RootState } from '../reducers/index';
import Cookies from 'universal-cookie';
import { v4 as uuid } from 'uuid';
import { config, dialogflowEvent, livechat, acceptanceIntent, zendeskErrorConfig } from '../config/config';
import { DialogflowQueryType, MessageTypes, Speaker } from './models/enum';
import './widget.scss';
import Header from './header/Header';
import Message from './message/Message';
import MessageQrArticle from './message/MessageQrArticle';
import MessageOrderTracking from './message/orderTracking/MessageOrderTracking';
import MessageQR from './message/MessageQR';
import MessageMenuQR from './message/MessageMenuQR';
import Article from './article/Article';
import Vote from './article/Vote';
import MessageLink from './message/MessageLink';
import MessageQuickEvent from './message/MessageQuickEvent';
import MessageQrDynamic from './message/MessageQrDynamic';
import TicketForm from './ticket-form/TicketForm';
import ThankYou from './thank-you/ThankYou';
import Loader from './loader/Loader';
import { eventQueryAsync, textQueryAsync } from './chatservice/dialogflowQuery';
import { handleMessageNewRoutine } from './models/messageHandler';
import { postMessageToClient } from './chatservice/communicationService';
import { Carousel } from './carousel/Carousel';
import zChat from '../zendesk/web-sdk';
import { MessageModel } from './models/messageModel';
import { isLiveChatAvailable, selectUserMessages, selectLiveChatMessages, sendLiveChatMessage, logEndChatReason } from './chatservice/liveChat';
import LiveChatMessage from './message/LiveChatMessage';
import LiveChatUserForm from './message/livechat/LiveChatUserForm';
import LiveChatRating from './message/livechat/LiveChatRating';
import MessageLiveChatQR from './message/MessageLiveChatQR';
import ManualEndSessionScreen from './message/sessionHandling/ManualEndSession';
import AutoEndSession from './message/sessionHandling/AutoEndSession';
import { StoreSelector } from './store-selector/StoreSelector';
import { ProductList } from './product-list/ProductList';
import {ProductNearbyStoreList} from './product-nearby-store-list/ProductNearbyStoreList';
import { FindAWine } from '../find-a-wine/FindAWine';
import { FAWProps } from '../find-a-wine/models/fawTypes';
import { openPdp, showFawPage, isBotOpenFirstTime, updateLCUserInitalPosition, updateLCUserPosition, isCustomQueueMessageTriggered } from '../actions/index';
import ArticleList from './message/ArticleList';
import ArticleDetail from './article/ArticleDetail';
import { updateLiveChatStatus, fetchLiveChatHours } from './chatservice/zendeskApis';
import { pickRandomString, getOrdinalSuffix, isMobileOS } from '../widget/util/commonUtil';
import { getDST } from '../widget/util/dateTimeHelper';

const cookies: Cookies = new Cookies();

let intervalFunction: any;
let timeoutAcceptance: any;
let globalBotTimeout: any;
let globalBotSessionAlive: any;
let lCQueueNotificationInterval: any;

let fawProps : FAWProps;

const Widget = () => {
    const messagesEndRef: any = useRef(null);
    const [isHostDevice, setIsHostDevice] = useState<any>((config.ISSTAGING) ? false : null);
    const [input, setInput] = useState<string>('');    
    const [messages, setMessages] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(false);
    const [openLiveChat, setOpenLiveChat] = useState<boolean>(false);
    const [showWidget, setShowWidget] = useState<boolean>(false); 
    const [showMurphyPopup, setShowMurphyPopup] = useState<boolean>(false); 
    const [murphyTyping, setMurphyTyping] = useState<boolean>(false); 
    const [showArticle, setShowArticle] = useState<boolean>(false);
    const [articleData, setArticleData] = useState<any>();
    const [paSelectedStoreData, setPaSelectedStoreData] = useState<any>();
    const [showTicketForm, setShowTicketForm] = useState<boolean>(false);
    const [showThankYou, setShowThankYou] = useState<boolean>(false);
    const [acceptIntentTriggeredOnQueryResp, setAcceptIntentTriggeredOnQueryResp] = useState<boolean>(false);
    
    const [showInputTextBox, setShowInputTextBox] = useState<boolean>(true);
    const [shouldInitWithWelcome, setShouldInitWithWelcome] = useState<boolean>(true);

    const [showUserForm, setShowUserForm] = useState<boolean>(false);
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [showLiveChatRating, setShowLiveChatRating] = useState<boolean>(false);
    const [liveChatRating, setLiveChatRating] = useState<string>("");
    const [showManualEndSessionScreen, setShowManualEndSessionScreen] = useState<boolean>(false);
    const [autoEndSessionScreen, setAutoEndSessionScreen] = useState<boolean>(false);
    const [timeoutType, setTimeoutType] = useState<number>(0);
    const [isLCReviewDone, setLCReviewDone] = useState<boolean>(false);
    const [lCQueueMessage, setLCQueueMessage] = useState<string[]>([]);
    

    const [liveChatComment, setLiveChatComment] = useState<string>("");
    const [unreadMessageCount, setUnreadMessageCount] = useState<number>(0);
    const [agentNames, setAgentNames] = useState<string[]>([livechat.HEADER_TEXT]);
    const queuePosition: any = useRef();
    const agentChatCount: any = useRef(0);
    const sessionId: any = useRef("");
    const intentGroupId: any = useRef("");
    const intentGroupPendingRenew: any = useRef(false);
    const queryId: any = useRef("");
    const intentGroupName: any = useRef("");
    const intentName: any = useRef("");
    const chatbotUserId: any = useRef("");
    const isLiveChatOn: any = useRef(false);
    const liveChatHours: any = useRef("");
    const dispatch = useDispatch();

    const pdpOpened = useSelector((state: RootState) => { return state.fawData.pdpOpened });
    const showFAW = useSelector((state: RootState) => { return state.fawData.showFAW });
    const fawStoreName = useSelector((state: RootState) => { return state.fawData.selectedStoreName });
    const fawStreetNumber = useSelector((state: RootState) => { return state.fawData.selectedStoreId });
    const isWidgetOpenFirstTime = useSelector((state: RootState) => { return state.botData.isWidgetOpenFirstTime });
    const lcUserInitialPosition = useSelector((state: RootState) => { return state.botData.liveChatUserInitialPosition });
    const liveChatUserQueuePosition = useSelector((state: RootState) => { return state.botData.liveChatUserQueuePosition });
    const customQueueMessageTriggered = useSelector((state: RootState) => { return state.botData.isCustomQueueMessageTriggered });
    
    const dialogFlowPing = async () => {
        //To keep session alive with dialog flow
        const params = {
            intentGroupName: intentGroupName.current,
            intentGroupId: intentGroupId.current,
            intentName: intentName.current,
            intentGroupPendingRenew: false
        };

        // set livechat availability parameter as false since its irrelevant to this event
        await eventQueryAsync(dialogflowEvent.KEEP_ALIVE, chatbotUserId.current, sessionId.current, false, params);
    }

    const manualDialogFlowPing = async () => {
        // show timeout screen after 10 mins
        resumeGlobalTimeout();
        dialogFlowPing();
    }
   
    const dialogflowEventQueryAsync = async (text : string, params: any = null) => {
        // show timeout screen after 10 mins
        resumeGlobalTimeout();
        
        //To keep session alive with dialog flow
        keepSessionAlive();
        const isLCAvailable = isLiveChatAvailable();

        if (params) {
            params['intentGroupName'] = intentGroupName.current;
            params['intentGroupId'] = intentGroupId.current;
            params['intentName'] = intentName.current;
            params['intentGroupPendingRenew'] = intentGroupPendingRenew.current;
        } else {
            params = {
                intentGroupName : intentGroupName.current,
                intentGroupId: intentGroupId.current,
                intentName: intentName.current,
                intentGroupPendingRenew: intentGroupPendingRenew.current
            }
        }

        // set the false after use
        intentGroupPendingRenew.current = false;
        
        const result = await eventQueryAsync(text, chatbotUserId.current, sessionId.current, isLCAvailable, params);

        // process response from DF
        const processedMessages = processDFQueryResponse(result);

        if (processedMessages.length > 0)
            setMessages((messages: []) => [...messages, ...handleMessageNewRoutine(processedMessages)]);
        setLoader(false);
    }

    const dialogflowTextQueryAsync = async (text : string) => {
        // remove timeout for acceptane rate
        clearTimeout(timeoutAcceptance);

        // show timeout screen after 10 mins
        resumeGlobalTimeout();

        //To keep session alive with dialog flow
        keepSessionAlive();

        

        const isLCAvailable = isLiveChatAvailable();

        const params = {
            intentGroupName : intentGroupName.current,
            intentGroupId: intentGroupId.current,
            intentName: intentName.current,
            intentGroupPendingRenew: intentGroupPendingRenew.current
        }

        // set the false after use
        intentGroupPendingRenew.current = false;

        const result = await textQueryAsync(text, chatbotUserId.current, sessionId.current, isLCAvailable, params);

        // process response from DF
        const processedMessages = processDFQueryResponse(result);

        if (processedMessages.length > 0)
            setMessages((messages: []) => [...messages, ...handleMessageNewRoutine(processedMessages)]);
        setLoader(false);
    }

    const processDFQueryResponse = (messages: MessageModel[]) => {

        let overrideResponse: string = "";
        let acceptanceRateTriggered: boolean = false;
        let productAvailFollowUpTriggered: boolean = false;

        for (let z = messages.length - 1; z >= 0; z--) {
            if (messages[z].type === MessageTypes.Message) {
                // if there is an override response, use that and override the response 
                messages[z].text = (overrideResponse !== '') ? overrideResponse : messages[z].text;
                overrideResponse = "";

                if (!acceptanceRateTriggered && messages[z].text.indexOf('Are you looking for a product') >= 0) {
                    acceptanceRateTriggered = true;
                    const params: any = {
                        acceptanceIntentName : 'PRODUCT AVAILABILITY-general-lookup'
                    }

                    initAcceptanceRate(params);
                    continue;
                } 

                if (!acceptanceRateTriggered && messages[z].text.indexOf('The product you’re looking for is not available anywhere') >= 0) {
                    acceptanceRateTriggered = true;
                    const params: any = {
                        acceptanceIntentName : getIntentName(messages[z].type)
                    }
                    initAcceptanceRate(params, acceptanceIntent.NEARBY_STORES_TIMEOUT);
                    continue;
                } 

                continue;
            }


            if (messages[z].type === MessageTypes.Command) {
                // execute command triggers
                executeCommand(messages[z].text);

                // remove item from array after command is executed
                messages.splice(z, 1);
                continue;
            }

            if (messages[z].type === MessageTypes.LiveChatMessage) {
                // remove item from array since message is just the command message
                messages.splice(z, 1);
                continue;
            }

            // save the session id and delete from message response
            if (messages[z].type === MessageTypes.SessionId) {
                sessionId.current = messages[z].text;
                messages.splice(z, 1);
                continue;
            }

            // save the intent group id and delete from message response
            if (messages[z].type === MessageTypes.QueryId) {
                queryId.current = messages[z].text;
                messages.splice(z, 1);
                continue;
            }

            // save the intent group id and delete from message response
            if (messages[z].type === MessageTypes.IntentGroupId) {
                intentGroupId.current = messages[z].text;
                messages.splice(z, 1);
                continue;
            }

            // save the intent group name and delete from message response
            if (messages[z].type === MessageTypes.IntentGroupName) {
                intentGroupName.current = messages[z].text;
                messages.splice(z, 1);
                continue;
            }

            // save the intent previous intent name and delete from message response
            if (messages[z].type === MessageTypes.IntentName) {
                intentName.current = messages[z].text;
                messages.splice(z, 1);
                continue;
            }

            // we need to manually remove live chat option because
            // we're stuck with using the sdk on the UI side
            if (messages[z].type === MessageTypes.ConditionalQr || (messages[z].type === MessageTypes.Form
                && (messages[z].text.toLowerCase() === 'send us a message' || messages[z].text.toLowerCase() === 'leave us a message'))) {               
                // block QR if not allowed
                if (!isQRAllowed(messages[z].text)) {
                    // override message to follow response from conditional QR
                    overrideResponse = (messages[z].unavailable_response) ? messages[z].unavailable_response : "";

                    // remove message since QR is not allowed
                    messages.splice(z, 1);
                    continue;
                }

            }

            if (messages[z].type === MessageTypes.QuickReply) {
                   messages[z]?.text.forEach((m: MessageModel)=> {
                        if(m.type === MessageTypes.ConditionalQr || m.type === MessageTypes.Form)
                        setLiveChatHoursSubtext(m);
                    });            
            }
        

            if (messages[z].type === MessageTypes.Stores || messages[z].type === MessageTypes.OrderTracking || messages[z].type === MessageTypes.Article 
                || messages[z].type === MessageTypes.ArticleList || messages[z].type === MessageTypes.ProductNearbyStore || messages[z].type === MessageTypes.Url) {
                const params: any = {
                    acceptanceIntentName : getIntentName(messages[z].type)
                }

                if (!acceptanceRateTriggered) {
                    acceptanceRateTriggered = true;
                    initAcceptanceRate(params);
                    continue;
                } 
            }

            if (messages[z].type === MessageTypes.Product) {
                if (!productAvailFollowUpTriggered) {
                    productAvailFollowUpTriggered = true;
                    initProductAvailFollowup();
                    continue;
                }
            }
        }
       
        return messages;
    }

    const setLiveChatHoursSubtext = (message: MessageModel) => {
        const messageText = message.text.toLowerCase();
        if (messageText === "live chat" || messageText == "send us a message" || messageText === "leave us a message") 
            { message.subtext = `Live chat operating hours (${getDST()}): ${liveChatHours.current[0]} - ${liveChatHours.current[1]}`}
    }

    const getIntentName = (messageType: string) => {
        let acceptanceIntentName: string = "" ;
        switch (messageType) {
            case MessageTypes.Stores:
                acceptanceIntentName = "STORE LOCATOR-address";
                break;
            case MessageTypes.OrderTracking:
                acceptanceIntentName = "ORDER TRACKING-delivery-type";
                break;
            case MessageTypes.Article:
            case MessageTypes.ArticleList:
                acceptanceIntentName = "FAQ-Default-Intent";
                break;
            case MessageTypes.Product:
                acceptanceIntentName = "PRODUCT AVAILABILITY-general-lookup";
                break;
            default:
                acceptanceIntentName = "Unknown Message Type";
                break;
        }

        return acceptanceIntentName;
    }

    // check if QR is currently allowed in curent chat state
    const isQRAllowed = (qrText: string): boolean => {
        let isAllowed: boolean = false;

        // other future conditional QRs can be expanded here
        switch (qrText.toLowerCase()) {
            case "live chat" : 
                isAllowed = isLiveChatAvailable();
                break;
            case "leave us a message":
            case "send us a message" : 
                isAllowed = !isLiveChatAvailable();
                break;
            default:
                break;
        }

        return isAllowed;
    }

    const executeCommand = (commandText: string) => {
        switch (commandText) {
            case "liveChatInit" :
                initLiveChat(false);

                // set cookie session variable to keep track that live chat is on
                // even on page refresh
                // TODO : Set cookie
                break;
            case "endBotSession" :
                setTimeoutType(3);
                setShowManualEndSessionScreen(true);

                // set cookie session variable to keep track that live chat is on
                // even on page refresh
                // TODO : Set cookie
                break;
            case "openFAWForm" :
                chooseWinePreference(fawStoreName, fawStreetNumber, intentGroupId.current, "FindAWine", 9);
                break;
            default :
                break;
        }
    }

    const initLiveChat = function(bypassUserForm:boolean = true) {
        // check if agents or chat is available before initiating the chat.
        // this part should be moved to chatserver when possible
        // check live chat availability again
        if (isLiveChatAvailable()) {
            // clear bot timeout
            clearTimeout(globalBotTimeout);
            
            // show live chat 
            isLiveChatOn.current = true;

            if (bypassUserForm === false) {
                // clear name and email first
                setName('');
                setEmail('');
                
                showUserInput(false);
                setShowUserForm(true);
            } else {
                // send the visitor info immdiately from variable
                const visitorInfo = getCookie("visitorInfo");

                zChat.setVisitorInfo(visitorInfo, function() {});

                // send history of messages as first message
                const messageHistory = getlocalStorage("messageHistory");
                const liveChatHistory = selectLiveChatMessages(getlocalStorage("allMessageHistory"));
                const combinedMessages = `${messageHistory}\n\n${liveChatHistory}`;
                sendLiveChatMessage(combinedMessages);
            }

            setArticleData({});
            setShowArticle(false);
            setShowTicketForm(false);   
            setShowThankYou(false);

            setLiveChatRating('');
            setLiveChatComment('');

            /* disabled for now
            intervalFunction = setInterval(() => {
                if (queuePosition.current > 0) {
                    setMessages((liveChatMessages: MessageModel[]) => 
                    [...liveChatMessages, 
                    ...[{ 
                            text: `It shouldn’t be too long now. If you don’t want to wait you can send us a message and we’ll get back to you as soon as we can.`,
                            from: Speaker.Murphy, 
                            type: MessageTypes.LiveChatMessage 
                        },
                        { 
                            text: "Send us a message", 
                            from: Speaker.Agent, 
                            type: MessageTypes.LiveChatQr
                        }
                        ]
                    ]);
                }                 
            }, livechat.LIVECHAT_TIMEOUT);*/
        } else {
            // display status to user
            setMessages((messages: any) => [...messages, ...[{ text: "Live Chat is currently unavailable.  Please check on of our other contact options.", from: Speaker.Agent, type: MessageTypes.Message }]]);
            dialogflowEventQueryAsync(dialogflowEvent.LIVECHAT_GETINTOUCH);
        }
    }

    const addToLiveChatMessages = (text: string, from: string, options?: string[]) => {
        setMessages((liveChatMessages: any) => 
            [...liveChatMessages, 
            ...[{ 
                    text: text, 
                    from: from, 
                    type: MessageTypes.LiveChatMessage 
                }]
            ]);

        if (options) {
            options.forEach(opt => {
                setMessages((liveChatMessages: MessageModel[]) => 
                    [...liveChatMessages, 
                    ...[{ 
                            text: opt, 
                            from: from, 
                            type: MessageTypes.Qr,
                            hasQr: true
                        }]
                    ]);
            });
        }

        if (!showWidget) {
            setUnreadMessageCount(unreadMessageCount => unreadMessageCount + 1);
        }
    };

    const addToStateArray = (name: string) => {
        var array = Array.from(agentNames); // make a separate copy of the array
        array.unshift(name);
        return array;
    }

    const ratingWindowDisplayDecision = () => {
        // wait 1.5 seconds and if no agent comes in, end the chat
        // check again if there are no agents left
        // show the rating request page 
        if (agentChatCount.current <= 0) {
            setLiveChatRating('');
            setLiveChatComment('');
            setShowLiveChatRating(true);
        }
    }

    const removeFromStateArray = (name: string) => {
        var array = Array.from(agentNames); // make a separate copy of the array
        
        var index = array.indexOf(name);
        if (index !== -1) {
            array.splice(index, 1);
        }
        
        return array;
    }

    const getLcQueueMessage = (queuePosition: number) => {
        const messages: string [][] = [];
        let queueWaitingMessage: string[] = [];
        let randomIndex: number;
        
        switch(true) {
            case (queuePosition >= 50): //eg: Queue position 50 and above
                        if(isMobileOS()) {
                            messages.push(
                                [`Hey ${name}, it's going to be a bit of a wait. Live chat is popular right now.`,
                                `You can navigate away from this page, but keep it open in the background. Please check back from time to time to see your progress in the queue.`],
                                [`Woah, what a queue! Sorry for the long wait, ${name}.`,
                                `Please keep this page open when you navigate to a different one and check back regularly to see your progress in line.`]);
                        } else {
                            messages.push(
                                [`Hey ${name} it is going to be bit of wait . Live chat is popular right now .`,
                                 `You can navigate away from this page, but keep it open in the background. You’ll get an audio notification once you have reached 3rd in place in the queue..`
                                ],
                                [`Hey ${name} it is going to be bit of wait . Live chat is popular right now .`,
                                  `Please keep this page open when you navigate to a different one and keep an 'ear' out for an audio notification.`
                                ]
                            )
                        }
                        randomIndex = Math.round(Math.random() * messages.length);
                        queueWaitingMessage = messages[randomIndex];
            break;
            case ( queuePosition <= 49 && queuePosition >= 10 )://eg: Queue position between 49 and 10
                if(isMobileOS()) {
                    messages.push(
                        [`You can navigate away from this page, but keep it open in the background. Please check back from time to time to see your progress in the queue.`],
                        [`Please keep this page open when you navigate to a different one and check back regularly to see your progress in line.`])
                } else {
                    messages.push(
                        [`You can navigate away from this page, but keep it open in the background. You'll get an audio notification once you reach 3rd place in the queue.`],
                        [`Please keep this page open when you navigate to a different one and keep an 'ear' out for an audio notification. I'll let you know once it's almost your turn.`])
                }
                randomIndex = Math.round(Math.random() * messages.length);
                queueWaitingMessage = messages[randomIndex];
            break;
            case queuePosition >= 5 && queuePosition <= 9: //eg: Queue position between 5 and 9
                queueWaitingMessage= [`Thank you for your patience. It shouldn't be too long now.`];
            break;
            default:
                queueWaitingMessage = [];
        }

        setLCQueueMessage(queueWaitingMessage);
    }

    const liveChatEvents = (data: any) => {
        switch (data.type) {
            case 'chat.msg' :
                if (data.msg.indexOf('LC Context') !== 0) {
                    const speaker = (data.nick === "agent:trigger" ) ? Speaker.Murphy : (data.nick.indexOf('visitor') >= 0) ? Speaker.User : Speaker.Agent;
                    addToLiveChatMessages(data.msg, speaker, data.options);
                }
                break;
            case 'chat.memberleave' :
                if (data.nick.includes("agent")) {
                    let agent_name:string = data.display_name.split(' ')[0];

                    addToLiveChatMessages(`${ agent_name } has left the chat`, Speaker.System);
                    
                    setAgentNames(removeFromStateArray(agent_name));

                    agentChatCount.current = parseInt(agentChatCount.current) - 1;

                    // trigger this countdown only if there are no more agents left
                    if (agentChatCount.current <= 0) {
                        intervalFunction = setTimeout(ratingWindowDisplayDecision, livechat.ENDCHAT_TIMEOUT);
                    }
                }
                break;
            case 'chat.request.rating' :
                setShowLiveChatRating(true);
                break;
            case 'typing' :
                setLoader(data.typing);
                break;
            case 'chat.queue_position':
                if (queuePosition.current !== data.queue_position && data.queue_position !== 0) {
                   addToLiveChatMessages(`You are now no ${data.queue_position} in the queue.`, Speaker.System);
                }

                if(!queuePosition.current) {
                    dispatch(updateLCUserInitalPosition(data.queue_position));
                }

                dispatch(updateLCUserPosition(data.queue_position));

                //Resetting back the triggered message for another group
                if(data.queue_position === 49 || data.queue_position === 9) {
                    dispatch(isCustomQueueMessageTriggered(false)); 
                }

                queuePosition.current = data.queue_position;
                break;
            default : 
                break;
        }
    }

    const closeUserForm = () => {
        setShowUserForm(false);

        let visitorInfo = {
            display_name : name,
            email        : email
        };

        // set user information
        zChat.setVisitorInfo(visitorInfo, function(err: any) {
            if (err) {
                console.log(`Unable to send name and email to agent.`);
            } 

            // set name and email to cookie
            setCookie("visitorInfo", visitorInfo);

            showUserInput(true); 

            // send history of messages as first message
            let initialLCMessagesForAgent = selectUserMessages(messages);
            initialLCMessagesForAgent = initialLCMessagesForAgent || 'User:  Live Chat'; //In case of opening live chat directly
            sendLiveChatMessage(initialLCMessagesForAgent);

            // set history to storage
            setlocalStorage("messageHistory", initialLCMessagesForAgent);
        });
    }

    const getCookie = (cookieName: string) => {
        if (cookies.get(cookieName) === undefined) {
            return null
        } else {
            return cookies.get(cookieName);
        }
    }

    const setlocalStorage = (storageName: string, storageObj: any) => {
        //var encrypted = CryptoJS.AES.encrypt(storageObj, "Avowed96Fairs66Wry");

        //const storageString = JSON.stringify(storageObj);
        //window.localStorage.setItem(storageName, encrypted);
    }

    const getlocalStorage = (storageName: string) => {
        var items = null; //window.localStorage.getItem(storageName);
        if (items === null) return null;

        return JSON.parse(items);
    }

    const setCookie = (cookieName: string, cookieObj: any) => {
        const cookieString = JSON.stringify(cookieObj);

        if (window.location.hostname === "localhost") {
            cookies.set(cookieName, cookieString, {
                domain: 'localhost'
            });
        } else {
            cookies.set(cookieName, cookieString, {
                path: '/', 
                domain: '.windows.net', 
                sameSite: 'none', 
                secure: true,
                maxAge: 31536000
            });
        }
    }


    const isSafeInput = () => {
        if (!input || input.trim() === '') {
            return false;
        }
        if ((input.length > 256 || input.length < 1) && isLiveChatOn.current === false) {
            setMessages((messages: any) => [...messages, ...[{ text: 'Sorry, I didn\'t quite get that - can you make your question shorter for me? I can only accept up to 256 characters', from: Speaker.System, type: MessageTypes.Message }]]);
            return false;
        }

        var regex = new RegExp(config.ALLOWED_CHARACTERS, 'i' );
        if (!input.match(regex)) {
            setMessages((messages: any) => [...messages, ...[{ text: 'Sorry, I didn\'t quite understand that - please use alphanumeric characters only', from: Speaker.System, type: MessageTypes.Message }]]);
            return false;
        }
        return true;
    }

  
    const sendMessage = (event : any)=> {
        event.preventDefault();

        // if the user is chatting with an agent, send message to livechat
        // if not, send to dialogflow
        const trimmedInput = input.trim();

        if (isLiveChatOn.current === true) {
            addToLiveChatMessages(trimmedInput, Speaker.User);
            sendLiveChatMessage(trimmedInput);
            setLoader(false);
        } else {
            // check validity of input
            if (!isSafeInput()) {
                return false;
            }
            
            setMessages((messages: any) => [...messages, ...[{ text: trimmedInput, from: Speaker.User, type: MessageTypes.Message }]]);
            dialogflowTextQueryAsync(trimmedInput);
            setLoader(true);
        }
        
        setInput('');
    }

    const chooseWinePreference = (storeName: string, streetNumber: string, intentGroupId: string, intentGroupName: string, intentGroupTypeId: number) => {
        fawProps = {
            storeName: storeName,
            streetNumber: streetNumber,
            resumeGlobalTimeout: () => resumeGlobalTimeout(),
            quickReplyHandler: (event:any, queryType : DialogflowQueryType, eventText: string, showText: boolean) => quickReplyHandler(event, queryType, eventText, showText),
            sessionId : sessionId.current,
            userId: chatbotUserId.current,
            intentGroupId: intentGroupId,
            intentGroupName: intentGroupName, 
            intentGroupTypeId: intentGroupTypeId
        }
        dispatch(showFawPage(true));
    }

    const handleAnalyticsBot = (linkName: string, linkType: string, methodHandler:string ) => {
        const objCall = {
            data : {
                linkName : linkName,
                linkType: linkType,
            },
            methodHandler : methodHandler
        };
        postMessageToClient(objCall);
    }

    const quickReplyHandler = (event: any, queryType : DialogflowQueryType = DialogflowQueryType.Text, eventText: string = "", showText: boolean = true, params:any = null, renew:boolean = false, intentGroupInfo:any = null) => {
        event.preventDefault();
        event.stopPropagation();
        // show timeout screen after 10 mins
        resumeGlobalTimeout();

        if (intentGroupInfo !== null) {
            intentGroupName.current = intentGroupInfo.intentGroupName;
            intentGroupId.current = intentGroupInfo.intentGroupId;
        }

        let text = event.currentTarget.textContent;
        if (event.currentTarget.className !== 'vote__button') {
            if (text.toLowerCase() === 'store stock availability') {
                
                handleAnalyticsBot('web:chatbot:linkname:store stock availability', 'chatbot product availability', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'find another product') {

                handleAnalyticsBot('web:chatbot:product availability:follow up:find another product', 'chatbot product availability', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'find nearby' && eventText === dialogflowEvent.PRODUCT_AVAIL_FIND_NEARBY_STORES) {

                handleAnalyticsBot(`web:chatbot:product availability:find nearby:${params.productData.productName}`, 'chatbot product availability find nearby', 'chatbotTriggerAdobeAnalytics');

            }  else if (text.toLowerCase() === "yes, i'm done") {

                handleAnalyticsBot('web:chatbot:product availability:follow up:yes I am done', 'chatbot product availability', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'change store') {

                handleAnalyticsBot('web:chatbot:product availability:follow up:change store', 'chatbot product availability', 'chatbotTriggerAdobeAnalytics');

            } else if ((text.toLowerCase() === 'select store') && (eventText === 'PRODUCT_AVAIL_SET_STORE')) {

                handleAnalyticsBot('web:chatbot:product availability:select store', 'chatbot product availability', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'help me choose a wine') {

                handleAnalyticsBot('web:chatbot:linkname:find a wine', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');
            
            } else if (text.toLowerCase() === 'yes, thanks' && eventText === dialogflowEvent.Chatbot_FAW_Followup_Questions) {

                handleAnalyticsBot('web:chatbot:find a wine:did i help you choose a wine:yes thanks', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'no' && eventText === dialogflowEvent.Chatbot_FAW_Followup_Questions) {

                handleAnalyticsBot('web:chatbot:find a wine:did i help you choose a wine:no', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');

            }  else if (text.toLowerCase() === 'yes, lets try again' && eventText === dialogflowEvent.Chatbot_FAW_Try_Again) {
                
                handleAnalyticsBot('web:chatbot:find a wine:would you like to try again:yes', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');
                
            } else if (text.toLowerCase() === 'no' && eventText === dialogflowEvent.Chatbot_FAW_Try_Again) {
               
                handleAnalyticsBot('web:chatbot:find a wine:would you like to try again:no', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');
                
            } else if (text.toLowerCase() === 'same store' && eventText === dialogflowEvent.Chatbot_FAW_Select_Store_Again) {
            
                handleAnalyticsBot('web:chatbot:find a wine:try different store:same store', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');

            } else if (text.toLowerCase() === 'choose a different store' && eventText === dialogflowEvent.Chatbot_FAW_Select_Store_Again) {

                handleAnalyticsBot('web:chatbot:find a wine:try different store:choose a different store', 'chatbot find a wine', 'chatbotTriggerAdobeAnalytics');
            
            } else {
                switch(text.toLowerCase()) {
                    case 'subscriptions':
                        handleAnalyticsBot('web:chatbot:linkname:subscription', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'manage subscription':
                        handleAnalyticsBot('web:chatbot:subscription:manage subscription', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'returns and refunds':
                        handleAnalyticsBot('web:chatbot:subscription:returns and refunds', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'how to subscribe':
                        handleAnalyticsBot('web:chatbot:subscription:how to subscribe', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'track subscriptions delivery':
                        handleAnalyticsBot('web:chatbot:subscription:track subscriptions delivery', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'delivery faqs':
                        handleAnalyticsBot('web:chatbot:subscription:delivery faqs', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'skip a subscriptions delivery':
                        handleAnalyticsBot('web:chatbot:subscription:manage subscription:skip a subscriptions delivery', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'cancel subscription':
                        handleAnalyticsBot('web:chatbot:subscription:manage subscription:cancel subscription', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'update my subscription':
                        handleAnalyticsBot('web:chatbot:subscription:manage subscription:update my subscription', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    case 'update my details':
                        handleAnalyticsBot('web:chatbot:subscription:manage subscription:update my details', 'chatbot subscription', 'chatbotTriggerAdobeAnalytics');
                        break;
                    default:
                        if(eventText !== dialogflowEvent.Chatbot_Additional_Questions && eventText !== dialogflowEvent.Chatbot_FAW_Followup_Questions) {
                            postMessageToClient({name: "chatbotQRClicked", text: text});
                        }
                        break;
                }
            }
        }

        // if live chat is on. handle Quick Replies differently
        if (isLiveChatOn.current === true) {
            addToLiveChatMessages(text, Speaker.User);
            sendLiveChatMessage(text);
            
        } else {
            if (showText) {
                setMessages((messages: any) => [...messages, ...[{ text: text, from: Speaker.User, type: MessageTypes.Message }]]);
            }
            setLoader(true);
            
            if (queryType === DialogflowQueryType.Text) {
                dialogflowTextQueryAsync(text);
            } else {
                dialogflowEventQueryAsync(eventText, params);
            }
        }

        if (renew === true) {
            // set pending renew back to false
            intentGroupPendingRenew.current = true;
        } else {
            intentGroupPendingRenew.current = false;
        }
    }

    const globalBotTimeoutHandler = () => {
        setTimeoutType(2);
        setShowManualEndSessionScreen(true);

        clearTimeout(globalBotTimeout);
        globalBotTimeout = setTimeout(() => {
            setShowManualEndSessionScreen(false);
            setAutoEndSessionScreen(true);

            sessionId.current = "";
            
            autoEndBotSession();
        }, config.AUTOEND_TIMEOUT);

    }


    useEffect(() => {
        if(openLiveChat) {
            toggleWidget();
            setLoader(true);
            dialogflowTextQueryAsync('Live Chat');
        } 
    }, [openLiveChat]);

    useEffect(() => {
        if(pdpOpened) {
            toggleWidget();
            dispatch(openPdp(false));
        } 
    }, [pdpOpened]);

    useEffect(() => {
        if(liveChatUserQueuePosition !== '') {
            //If the initial position was 10 or more then notify the user on queue position less than or equal to 5
            if(lcUserInitialPosition >= 10 && (liveChatUserQueuePosition <= 5)) {
                const displayText = liveChatUserQueuePosition === 0 ? 'Murphy messaged you. Agent joined.' : `Murphy messaged you. You're ${liveChatUserQueuePosition}${getOrdinalSuffix(liveChatUserQueuePosition)} in line`;
                postMessageToClient({name: "notifyUser", text: displayText, queuePosition: liveChatUserQueuePosition });
            }

            (liveChatUserQueuePosition !== 0) && getLcQueueMessage(liveChatUserQueuePosition);
        }
    }, [liveChatUserQueuePosition]);
    

    useEffect(() => {
            if(!customQueueMessageTriggered && lCQueueMessage && lCQueueMessage.length) {
                clearInterval(lCQueueNotificationInterval);
                lCQueueNotificationInterval = setTimeout(() => {
                    lCQueueMessage.forEach(queueMessage => {
                        addToLiveChatMessages(queueMessage, Speaker.Murphy);
                    })
                    dispatch(isCustomQueueMessageTriggered(true));
                }, 6000)
            }
    }, [customQueueMessageTriggered, lCQueueMessage]);

    useEffect(() => {
        if(!isWidgetOpenFirstTime && !showWidget) {
            toggleWidget();
            dispatch(isBotOpenFirstTime(true));
        } 

        if(!isWidgetOpenFirstTime && showWidget) {
            dispatch(isBotOpenFirstTime(true)); //Resetting
        }
    }, [isWidgetOpenFirstTime]);

    const openWelcomeMessage = () => {
        setLoader(true);
        dialogflowEventQueryAsync(dialogflowEvent.Dans_Chatbot_Welcome).then(() => {
            setLoader(true);
            dialogflowEventQueryAsync(dialogflowEvent.Chatbot_Article_FirstSuggestions);
        });
    }

    const toggleWidget = (toggledByPopup?:boolean) => {
        if (shouldInitWithWelcome && isWidgetOpenFirstTime) {
            setShouldInitWithWelcome(false);
            setShowManualEndSessionScreen(false);
            setAutoEndSessionScreen(false);
            if(!openLiveChat) {
                openWelcomeMessage();
            }
        }

        // set the unread count to 0 if the user opens or closes the widget
        setUnreadMessageCount(0);

        setShowWidget(!showWidget);

        const objCall = {
            data : {showWidget : !showWidget},
            methodHandler : "toggleWidget"
        };

        postMessageToClient(objCall);

        if (!showWidget) {
            //skip call to client for analytics in case bot opened by popup click
            if(!toggledByPopup){
                postMessageToClient({name: "chatbotOpened"});
                setShowMurphyPopup(false);
            } 
        }
    }

    const closeButton = () => {
        if (!showManualEndSessionScreen) {
            setTimeoutType(1);
            setShowManualEndSessionScreen(true);
        }

        if (autoEndSessionScreen) {
            // just minimize the widget if the session has already ended
            setShowWidget(false);

            const objCall = {
                data : {showWidget : false},
                methodHandler : "toggleWidget"
            };
    
            postMessageToClient(objCall);
        }
    }

    const backToWidget = (hasVoted:boolean = false) => {


        resumeGlobalTimeout();

        setArticleData({});
        setShowArticle(false);
        setShowTicketForm(false);   
        setShowThankYou(false);    

        isLiveChatOn.current = false;
        setShowInputTextBox(true);
        setShowUserForm(false);

        if (hasVoted !== true && !acceptIntentTriggeredOnQueryResp) {
            const params: any = {
                acceptanceIntentName : 'FAQ-Default-Intent'
            }

            initAcceptanceRate(params);
        }

        if(openLiveChat) {
            openWelcomeMessage();
            setOpenLiveChat(false);
        }
    }

    const resumeGlobalTimeout = () => {
        if (globalBotTimeout) clearTimeout(globalBotTimeout);
        globalBotTimeout = setTimeout(globalBotTimeoutHandler, config.IDLE_TIMEOUT);
    }

    //Bot session dialog flow pings

    const keepSessionAlive = () => {
        if(!globalBotSessionAlive) {
            globalBotSessionAlive = setInterval(dialogFlowPing, config.SESSION_ALIVE_PING);
        }
    }

    const clearBotSession = () => {
        clearInterval(globalBotSessionAlive);
        globalBotSessionAlive = '';
    }

    const initAcceptanceRate = (params: any = null, timeout: number | null = null) => {
        setAcceptIntentTriggeredOnQueryResp(false); 
        timeout = timeout ?? acceptanceIntent.DEFAULT_TIMEOUT;
        timeoutAcceptance = setTimeout(() => {
            // fire event
            if (params === null) {
                dialogflowEventQueryAsync(dialogflowEvent.Chatbot_Contact_Options);  
            } else {
                dialogflowEventQueryAsync(dialogflowEvent.Chatbot_Contact_Options, params);
            }
            setAcceptIntentTriggeredOnQueryResp(true); 
        }, timeout);
    }

    const initProductAvailFollowup = (params: any = null, timeout: number | null = null) => {
        setAcceptIntentTriggeredOnQueryResp(false); 
        timeout = timeout ?? acceptanceIntent.DEFAULT_TIMEOUT;
        timeoutAcceptance = setTimeout(() => {
            // fire event
            if (params === null) {
                dialogflowEventQueryAsync(dialogflowEvent.PRODUCTAVAIL_FOLLOWUP);  
            } else {
                dialogflowEventQueryAsync(dialogflowEvent.PRODUCTAVAIL_FOLLOWUP, params);
            }
            setAcceptIntentTriggeredOnQueryResp(true); 
        }, timeout);
    }

    const showUserInput = (show: boolean) => {
        setShowInputTextBox(show);
    }

    const openArticle = (data:any) => {
        // remove timeout for acceptane rate
        clearTimeout(timeoutAcceptance);
        setShowArticle(true);
        setArticleData(data);
    } 

    const onSubmitTicket = () => {
        setShowThankYou(true);
        setShowTicketForm(false);
    }

    const scrollToBottom = () => {
        messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    };

    const setRatingValue = (value: number) => {
        switch (value) {
            case 1: 
                setLiveChatRating(liveChatRating === 'good' ? '' : 'good')
                break;
            case -1: 
                setLiveChatRating(liveChatRating === 'bad' ? '' : 'bad')
                break;
            default:
                break;
        }
    }

    const startBotSession = () => {
        setAutoEndSessionScreen(false);
        setShowManualEndSessionScreen(false);

        setLoader(true);
        dialogflowEventQueryAsync(dialogflowEvent.Dans_Chatbot_Welcome).then(() => {
            setLoader(true);
            dialogflowEventQueryAsync(dialogflowEvent.Chatbot_Article_FirstSuggestions);
            setShouldInitWithWelcome(false);
        });             
    }

    const endBotSession = (value: boolean) => {
        switch (value) {
            case true: 
                // end live chat
                endLiveChat("Triggered by end session screen");

                // set the unread count to 0 if the user opens or closes the widget
                setUnreadMessageCount(0);

                setShowUserForm(false);

                setShowLiveChatRating(false);

                setOpenLiveChat(false);

                dispatch(showFawPage(false));

                // minimize widget
                setShowWidget(false);
                
                const objCall = {
                    data : {showWidget : false},
                    methodHandler : "toggleWidget"
                };
        
                postMessageToClient(objCall);

                // clear all messages 
                setMessages([]);

                // clear session id
                sessionId.current = "";
                
                clearAnalyticsVariables();
                
                setShouldInitWithWelcome(true);
                
                //Clear bot session interval
                clearBotSession();

                // launch Medallia
                !isLCReviewDone && launchMedallia();
                setLCReviewDone(false);
                
                break;
            case false: 
                setLCReviewDone(false);
                manualDialogFlowPing();
                break;
            default:
                break;
        }

        setShowManualEndSessionScreen(false);
    }

    const clearAnalyticsVariables = () =>{
        intentGroupId.current = "";
        intentGroupName.current = "";
        intentGroupPendingRenew.current = false;
        queryId.current = "";
    }

    const autoEndBotSession = () => {
        setUnreadMessageCount(0);

        // clear all messages 
        setMessages([]);

        setShouldInitWithWelcome(true);

        // clear session id
        sessionId.current = "";

         //Clear bot session interval
         clearBotSession();
    }

    const postLiveChatAvailabilityToHC = () => {
        const objCall = {
            data : { isLCAvailable: isLiveChatAvailable()},
            methodHandler : "isLCAvailable"
        };

        postMessageToClient(objCall);
    }

    //initial load
    useEffect(() => {
        if (cookies.get(config.COOKIES_CHATBOT_USER_ID_TEXT) === undefined) {
            chatbotUserId.current = uuid();
            cookies.set(config.COOKIES_CHATBOT_USER_ID_TEXT, chatbotUserId.current, {
                path: '/', 
                domain: '.windows.net', 
                sameSite: 'none', 
                secure: true,
                maxAge: 31536000
            });
        } else {
            chatbotUserId.current = cookies.get(config.COOKIES_CHATBOT_USER_ID_TEXT);
        }

        zChat.on('connection_update', function(event_data: any) {
            if (event_data === "connected") {
                try {
                    zChat.setVisitorDefaultDepartment(parseInt(config.ZENDESK_LIVECHAT_GROUP_ID),() => {
                        postLiveChatAvailabilityToHC();
                    });
                } catch(err) {}
                
                const isChatting = zChat.isChatting();
                if (isChatting === true) {
                    const agentsInChat = zChat.getServingAgentsInfo();

                    // if the user is currently in live chat disconnect
                    // and start a new session
                    addToLiveChatMessages("Resuming Live Chat.", Speaker.System);

                    setShouldInitWithWelcome(false);

                    // clear bot timeout
                    clearTimeout(globalBotTimeout);

                    // make sure live chat is on when agent is joined in a chat with the user
                    isLiveChatOn.current = true;

                    if (agentsInChat.length > 0 && agentChatCount.current === 0) {
                        agentChatCount.current = parseInt(agentChatCount.current) + 1;
                        const agent_name:string = agentsInChat[agentsInChat.length - 1].display_name.split(' ')[0];

                        setAgentNames(addToStateArray(agent_name));
                        addToLiveChatMessages(`${ agent_name } has joined`, Speaker.System);
                    }
                }
            }else {
                handleZendeskConnectionError(event_data);
            }
        });

        zChat.on('visitor_update', function (data: any) {
            setName(data.display_name);
            setEmail(data.email);
        });

        zChat.on('agent_update', function (data: any) {
            if (data.nick.indexOf('agent') >= 0) {
                agentChatCount.current = parseInt(agentChatCount.current) + 1;
                const agent_name:string = data.display_name.split(' ')[0];

                setAgentNames(addToStateArray(agent_name));
                addToLiveChatMessages(`${ agent_name } has joined`, Speaker.System);

                // if an agent joins the conversation
                // update analytics
                updateLiveChatStatus(sessionId.current, chatbotUserId.current, intentGroupId.current, true);
                // then renew the intent group
                intentGroupPendingRenew.current = true;
            }
        })

        // initiate zendesk widget
        // this is necessary to be able to check availability of zendesk agents 
        if (zChat.getConnectionStatus() === 'closed') {
            zChat.init({
                account_key: config.ZENDESK_CHAT_CONNECTION
            });

            // set live chat events
            zChat.on('chat', liveChatEvents);
        }

        // make sure the live chat overlays and form are down
        setShowUserForm(false);
        setShowLiveChatRating(false);

        // this will not be used for the moment 
        // until the time we need to link the user data from 
        window.addEventListener("message", messageHandler, false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        window.localStorage.setItem('messageLength', '0');
        // COMMENTING TILL CACHING IMPLEMENTATION
        //fetchLiveChatHours().then(res => liveChatHours.current = res?.data);
    }, []);


    const handleZendeskConnectionError = (event_data: any) => {
        switch (event_data) {
            case "connecting": resetLiveChatOnError();
                break;
                // consider connection lost in case of null or closed.
            case null:
            case "closed":
                setLoader(true);
                resetLiveChatOnError();
                setTimeout(() => {
                    setMessages((messages: []) => [...messages, ...[{ text: pickRandomString(zendeskErrorConfig.ERROR_RESPONSE_ARRAY), from: Speaker.Murphy, type: MessageTypes.Message }]]);
                    setLoader(false);
                }, 3000);
                break;
            default: break;
        }
    }


    const resetLiveChatOnError = () => {
        if (isLiveChatOn.current === true) {
            // if the user is currently in live chat disconnect
            // and start a new session
            addToLiveChatMessages("There has been a disruption.  Please check your connection.", Speaker.System);
            agentChatCount.current = 0;
            setAgentNames([livechat.HEADER_TEXT]);
            resumeGlobalTimeout();
            // set the default value of live chat status to false
            isLiveChatOn.current = false;
        }
    }

    const launchMedallia = () => {
        const dolaunch = messages.some((message: { from: Speaker; }) => {
            return message.from === Speaker.User 
        });

        if (dolaunch) {
            // if user has entered more than one query launch medallia
            const objCall = {
                data : {},
                methodHandler : "launchMedallia"
            };

            postMessageToClient(objCall);
        }
    }

    const messageHandler = (event: any) => {
        let params = event.data;

        switch (params.methodHandler) {
            case "setIsHostDevice":
                setIsHostDevice(params.data.setIsHostDevice === true)
                break;
            case "changeCustomerId":
                // change customer id
                chatbotUserId.current = params.data.id.toString();
                break;
            case "openWidget":
                if(!showWidget) {
                    const messageHistory = window.localStorage.getItem("messageLength");
                    if(messageHistory === '0') {
                      toggleWidget();
                    } else {
                        dispatch(isBotOpenFirstTime(false));
                    }
                }
                break;
            case "sendMessage":
                sendMessageFromBackground(params.data.messageString);
                break;
            case "openLiveChatOnBot":
               setOpenLiveChat(true);
               break;
            case "getLiveChatStatusFromBot":
                postLiveChatAvailabilityToHC();
                break;
            case "showMurphyPopup":
                handleMurphyPopup(params.data.setShowMurphyPopup);            
                break;
            default:
                break;
        }
    }

    const sendMessageFromBackground = (messageString: string) => {
        // if the user is chatting with an agent, send message to livechat
        // if not, send to dialogflow
        if (isLiveChatOn.current === true) {
            addToLiveChatMessages(messageString, Speaker.User);
            sendLiveChatMessage(messageString);
            setLoader(false);
        } else {
            setMessages((messages: any) => [...messages, ...[{ text: messageString, from: Speaker.User, type: MessageTypes.Message }]]);
            dialogflowTextQueryAsync(messageString);
            setLoader(true);
        }
    }

    useEffect(scrollToBottom);

    useEffect(() => {
    }, [isHostDevice]);

    useEffect(() => {
        // save conversation to session storage
        setlocalStorage("allMessageHistory", messages);
        window.localStorage.setItem("messageLength", messages.length);
    }, [messages]);

    const closeLiveChatRating = (event: any) => {
        event.preventDefault();

        setShowLiveChatRating(false);

        endLiveChat("Natural end live chat session");

        setTimeoutType(4);
        setShowManualEndSessionScreen(true);
        setLCReviewDone(true);
    }

    

    const endLiveChat = (endLiveChatReason = "") => {
        // send rating
        if (liveChatRating !== '') {
            zChat.sendChatRating(liveChatRating, function() {
                console.log("Live chat rating sent.");
            });    
        }

        // send comment
        if (liveChatComment !== '') {
            zChat.sendChatComment(liveChatComment, function() {
                console.log("Live chat comment sent.");
            });
        }
        
        if (zChat.isChatting()) {
            zChat.endChat({ clear_dept_id_on_chat_ended: true }, function() {
                console.log("live chat ended.");
            });
        }

        // set agent counts to 0
        agentChatCount.current = 0;
        
        addToLiveChatMessages("Live Chat has ended.", Speaker.System);

        isLiveChatOn.current = false;

        // remove chat related cookies
        cookies.remove("visitorInfo");
        
        // reset agent name array
        setAgentNames([livechat.HEADER_TEXT]);

        // clear live chat interval markers
        clearInterval(intervalFunction);

        clearInterval(lCQueueNotificationInterval);
        
        resumeGlobalTimeout();

        // pass logging to chatserver
        logEndChatReason(chatbotUserId.current, sessionId.current, endLiveChatReason);
    }

    function handleMurphyPopup(showMurphyPopup: any) {
        if (showMurphyPopup) {
            setShowMurphyPopup(false);
            setMurphyTyping(true);
            setTimeout(() => {
                setMurphyTyping(false);
                setShowMurphyPopup(showMurphyPopup);
            }, 2000);
        } else setShowMurphyPopup(showMurphyPopup);
    }

    const closeMurphyPopup = (event?:any,fireAnalytics:boolean = true) => {
        event?.stopPropagation();
        setShowMurphyPopup(false);
        if(fireAnalytics)
        handleAnalyticsBot('web:chatbot:auto pop up:close', 'chatbot auto pop up', 'chatbotTriggerAdobeAnalytics');
    }

    const onMurphyPopupClick = () => {
         // reset to first time to trigger welcome intent.
        setShouldInitWithWelcome(true);
        dispatch(isBotOpenFirstTime(true));
        toggleWidget(true);
        closeMurphyPopup(null,false);
        handleAnalyticsBot('web:chatbot:auto pop up:open', 'chatbot auto pop up', 'chatbotTriggerAdobeAnalytics');
    }

    return (
        <div>
            {showWidget &&
            <div className={"widget "+ (showWidget && "widget--open ") + (isHostDevice ? "widget--device" : "widget--website")}>                    
                
                <div className={"widget__header "+ (!isHostDevice && "widget__header--website")}>
                    <Header name={showArticle? config.ARTICLE_TEXT : showTicketForm? config.TICKET_FORM_HEADER_TEXT : showThankYou ? config.MESSAGE_SENT : isLiveChatOn.current ? agentNames[0] : config.HEADER_TEXT} 
                        toggleWidget ={toggleWidget} 
                        closeButton={closeButton} 
                        backToWidget={showArticle || showTicketForm || showThankYou ? backToWidget : () => {}}
                        isAgentName={ agentNames.length > 1 }
                        />                      
                </div>

                { showUserForm &&
                    <LiveChatUserForm setName={ setName } 
                        setEmail = { setEmail } 
                        email = { email } 
                        name = { name } 
                        backToWidget = { backToWidget } 
                        closeUserForm = { closeUserForm } 
                    />
                }

                { showLiveChatRating &&
                    <LiveChatRating liveChatRating={liveChatRating} setRatingValue={setRatingValue} closeLiveChatRating={closeLiveChatRating} liveChatComment={liveChatComment} setLiveChatComment={setLiveChatComment} />
                }

                { showManualEndSessionScreen &&
                    <ManualEndSessionScreen endBotSession={endBotSession} timeoutType={timeoutType} />
                }

                { autoEndSessionScreen &&
                    <AutoEndSession startBotSession={startBotSession} />
                }

                {
                    showFAW && <FindAWine {...fawProps}/>
                }
      
                <div className={"widget__body " + (showArticle ? "widget__body--article" : showThankYou ? "widget__body--success" : showTicketForm ? "" : "widget__body--messages")}>
                    {showArticle ? <ArticleDetail sessionId={sessionId.current} userId={chatbotUserId.current} data={articleData} /> : 
                        showTicketForm ? <TicketForm showThankYou={onSubmitTicket}/> :
                            showThankYou ? <ThankYou onGoBackClick={backToWidget}/> :
                                    <div className="widget__messages">                          
                                        {messages.map((m: any, index: number) => (
                                            <div key={index} 
                                                className={m.from === Speaker.User ? "widget__message-right" : m.type !== MessageTypes.Message && (m.type !== MessageTypes.OrderTracking && m.type !== MessageTypes.LiveChatMessage && m.type !== MessageTypes.QuickReply) ?  "widget__message-qr" : "widget__message-left"}>                                        
                                                    {m.type === MessageTypes.Message && <Message message={m} isHostDevice={isHostDevice}/>}
                                                    {m.type === MessageTypes.LiveChatMessage && <LiveChatMessage liveChatMessage={m} />}
                                                    {m.type === MessageTypes.Article && <MessageQrArticle message={m} clickHandler={openArticle}/>}
                                                    {m.type === MessageTypes.ArticleList && <ArticleList message={m} clickHandler={openArticle}/>}
                                                    {m.type === MessageTypes.Stores && <Carousel stores={m.data} isHostDevice={isHostDevice}/>}
                                                    {m.type === MessageTypes.PAStoreSelector && <StoreSelector stores={m.data} isHostDevice={isHostDevice} setSelectedStoreData = {setPaSelectedStoreData} quickReplyHandler={quickReplyHandler} />}
                                                    {m.type === MessageTypes.StoreSelector && <Carousel stores={m.data} isHostDevice={isHostDevice} chooseWinePreference={chooseWinePreference}  sessionId={sessionId.current} userId={chatbotUserId.current} />}
                                                    {m.type === MessageTypes.Product && <ProductList sessionId={sessionId.current} userId={chatbotUserId.current} products={m.products} toggleWidget={toggleWidget} selectedStore = {paSelectedStoreData} quickReplyHandler={quickReplyHandler}/>}
                                                    {m.type === MessageTypes.ProductNearbyStore && <ProductNearbyStoreList nearbyStores={m.stores} isHostDevice={isHostDevice} toggleWidget={toggleWidget}/>}
                                                    {m.type === MessageTypes.OrderTracking && <MessageOrderTracking message={m} />}
                                                    {/* {m.type === MessageTypes.QuickReply &&  m.text.length && m.text.map((message: any, index: number) => (                                
                                                        <span key={index}>{!!message.subtext && <span className="widget__message-subtext">{message.subtext}</span>}</span>))}                              */}
                                                    {m.type === MessageTypes.QuickReply && 
                                                        <div className="widget__message-qr-container">
                                                            { m.text.length && m.text.map((message: any, index: number) => (                                
                                                                <div key={index} >
                                                                    { message.type === MessageTypes.Qr && <MessageQR text={message.text} eventText={message.eventText} quickReplyHandler={quickReplyHandler}/> }
                                                                    { message.type === MessageTypes.ConditionalQr && <MessageQR text={message.text} quickReplyHandler={quickReplyHandler} /> }
                                                                    { message.type === MessageTypes.DynamicQr && <MessageQrDynamic message={message} quickReplyHandler={quickReplyHandler} sessionId={sessionId.current} userId={chatbotUserId.current} />}
                                                                    { message.type === MessageTypes.Help && <MessageLink text={message.text} link={config.DAN_HELP_CENTRE_URL} />}
                                                                    { message.type === MessageTypes.Form && <MessageLink text={message.text} link={config.DAN_CONTACT_US_FORM_URL} sessionId={sessionId.current} userId={chatbotUserId.current} intentGroupId={ message.intentGroupId } type={message.type} />} 
                                                                    { message.type === MessageTypes.Url && <MessageLink text={message.text} link={message.uri} sessionId={sessionId.current} userId={chatbotUserId.current} intentGroupId={ message.intentGroupId } type={message.type} />} 
                                                                    { message.type === MessageTypes.LiveChatQr && <MessageLiveChatQR text={message.text} link={config.DAN_CONTACT_US_FORM_URL} callBackFn={endLiveChat} />} 
                                                                    { message.type === MessageTypes.End && <MessageQuickEvent text={message.text} quickReplyHandler={quickReplyHandler} eventName={dialogflowEvent.End_Interaction} showTextResponse={true}/>}
                                                                    { message.type === MessageTypes.QrEvent && <MessageQuickEvent text={message.text} quickReplyHandler={quickReplyHandler} eventName={dialogflowEvent.Chatbot_Article_FirstSuggestions} showTextResponse={false}/>}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                            </div>
                                        ))}
                                        {loader ? <Loader /> : null}
                                        <div ref={messagesEndRef} />
                                    </div>
                    }
                </div>
                
                {!showArticle && !showTicketForm && !showThankYou &&
                    <div className={"widget__footer "+ (!isHostDevice && "widget__footer--website")}>                   
                        <form className="widget__footer-form">
                            <input autoFocus={!isHostDevice}
                                type="text"
                                className={`widget__footer-input ${!showInputTextBox ? 'hide': ''}`}
                                value={input}
                                onChange={event => setInput(event.target.value)}
                                placeholder="Type a message" />
                                <button type="submit"
                                    disabled={!input}
                                    onClick={sendMessage}
                                    className={`widget__footer-button ${!showInputTextBox ? 'hide': ''}`}>
                                </button>
                        </form>
                    </div>
                }
                
                {showArticle && articleData != null && <Vote sessionId={sessionId.current} userId={chatbotUserId.current} data={articleData} backToWidget={backToWidget} quickReplyHandler={quickReplyHandler} />}
            </div>}
            
            {!showWidget && isHostDevice !== null && showMurphyPopup && <div className="widget__popup-message" onClick={onMurphyPopupClick}>
                <img src="/images/icons-system-close.svg" className="widget__popup-close-icon" alt="Murphy" onClick={(e)=>closeMurphyPopup(e)}/>
                <p><span className="widget__hand-wave">&#128075;</span> Hi, I'm Murphy! <br/>Ask me a question if you need help.</p></div>}

            {!showWidget && isHostDevice !== null && !murphyTyping &&
            <button onClick={()=>toggleWidget()} className={"widget__button " + (!showWidget && "widget__button--show ")}>
                { unreadMessageCount > 0 && <span className="widget__unread">{unreadMessageCount}</span> } 
                <span className={"widget__button-icon " + (!isHostDevice && "widget__button-icon--website")}> 
                    <img src="/images/chatbot-murphy-no-border.png" alt="Murphy" className="widget__button-icon-logo" />
                </span>
            </button>
            }

            {!showWidget && isHostDevice !== null && murphyTyping &&
            <button onClick={()=>toggleWidget()} className={"widget__button " + (!showWidget && "widget__button--show ")}>
                <div className="widget__chat-bubble">
                    <div className="widget__loading">
                        <div className="widget__dot one"></div>
                        <div className="widget__dot two"></div>
                        <div className="widget__dot three"></div>
                    </div>
                    <div className="widget__tail"></div>
                    </div>
            </button>
            }
        </div>    
    )
}

export default Widget

